// extracted by mini-css-extract-plugin
export default {"container":"UfUJF"};